import { useParams, useSearchParams } from "react-router-dom";
import Breadcrumbs from "../../../components/breadcrumbs";
import { useEffect, useState } from "react";
import NotFound from "../../../components/not-found";
import AllergyCategoryService from "../../../services/AllergyCategoryService";
import AllergyCategoryEditForm from "./ui/allergy-category-edit-form";
import AllergyCategorySkeleton from "./skeletons/allergy-category-skeleton";
import AllergiesTable from "./ui/allergies-table";
import { AllergyCategoryViewModel } from "../../../viewModels";

export default function AllergyCategoryEditPage() {
  const [searchParams] = useSearchParams();

  const { id } = useParams<{ id: string }>();
  const [category, setCategory] = useState<AllergyCategoryViewModel | null>(
    null
  );
  const [loading, setLoading] = useState(true);
  const api = new AllergyCategoryService();

  useEffect(() => {
    if (id) {
      api
        .getAllergyCategory(id)
        .then((data) => {
          setCategory(data);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        });
    }
  }, [id, searchParams.get("reload")]);

  if (!loading && !category)
    return (
      <NotFound
        message="Category not found."
        backUrl="/admin/allergy-categories"
      ></NotFound>
    );

  return (
    <main className="max-w-3xl">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Allergy Categories", href: "/admin/allergy-categories" },
          {
            label: "Edit",
            href: `/admin/allergy-categories/edit/${id}`,
            active: true,
          },
        ]}
      />
      {loading ? <AllergyCategorySkeleton /> : null}

      {!loading && category ? (
        <>
          <AllergyCategoryEditForm category={category} />
          <AllergiesTable category={category}></AllergiesTable>
        </>
      ) : null}
    </main>
  );
}
